<template>
  <div>
    <h1>Lista de Municipios</h1>
    <b-card>
      <div class="d-flex mb-2">
        <div class="mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div></div>
      </div>

      <b-table striped hover :items="municipios" :fields="fields" show-empty>
        <template #cell(capital)="{ item }">
          <div>
            <font-awesome-icon
              v-if="item.capital"
              icon="square-check"
              class="text-success"
            />
            <font-awesome-icon v-else icon="square" class="text-light" />
          </div>
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>

        <template #cell(actions)="{ item }">
          <Actions
            :item="item"
            :view_show="true"
            :view_edit="false"
            :view_delete="false"
            view_to="municipios_show"
          />
        </template>
      </b-table>
    </b-card>

    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        @input="loadData()"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        size="sm"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
  }),
  computed: {
    ...mapState("municipios", ["municipios", "pagination"]),
    fields() {
      return [
        { key: "id", label: "IBGE", class: "col-1" },
        { key: "nome", label: "Nome" },
        { key: "estado_sigla", label: "UF", class: "col-1 text-center" },
        { key: "capital", label: "Capital", class: "col-1 text-center" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("municipios", ["ActionGetAll", "ActionDelete"]),
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    searchTerm() {
      this.page = 1;
      this.loadData();
      this.$router.push({
        query: {
          page: this.page,
          q: this.termo_pesquisa,
        },
      });
    },
    async loadData() {
      try {
        await this.ActionGetAll({ page: this.page, q: this.termo_pesquisa });
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
  },
  watch: {
    page() {
      if (this.pagination.current_page != this.page) {
        this.loadData();
      }
    },
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
};
</script>

<style></style>
